import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import { faPhone } from "@fortawesome/free-solid-svg-icons/faPhone";
import { faPhoneSquare } from "@fortawesome/free-solid-svg-icons/faPhoneSquare";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";

export function prepareFontAwesome() {
  library.add(faAngleDown, faEdit, faPhone, faPhoneSquare, faUser);
}
